import { Component, OnInit } from '@angular/core';
import { DestructorComponent } from 'src/app/components/destructor/destructor.component';
import { GlobalStateService } from 'src/app/services/global/global-state.service';

declare var bootstrap: any;

@Component({
  selector: 'app-view-docs-release-data',
  templateUrl: './view-docs-release-data.component.html',
  styleUrls: ['./view-docs-release-data.component.scss']
})
export class ViewDocsReleaseDataComponent extends DestructorComponent implements OnInit {

  docsReleaseData: any = null;
  countries: any[] = [];

  constructor(
    private _globalStateService: GlobalStateService
  ) {
    super();
  }

  ngOnInit(): void {
    this.loadCountries();
    this.setupModalListener();
  }

  private setupModalListener(): void {
    const modalElement = document.getElementById('kt_modal_view_docs_release_data');
    if (modalElement) {
      modalElement.addEventListener('show.bs.modal', () => {
        const selectedData = (window as any).selectedDocsReleaseDataForView;
        if (selectedData) {
          this.docsReleaseData = selectedData;
        }
      });

      modalElement.addEventListener('hidden.bs.modal', () => {
        this.resetData();
      });
    }
  }

  private loadCountries(): void {
    this.subscriptions.push(
      this._globalStateService.GetCountries().subscribe({
        next: (countries: any) => {
          if (countries && Array.isArray(countries)) {
            this.countries = countries;
          }
        },
        error: (error: any) => {
          console.error('Error loading countries:', error);
        }
      })
    );
  }

  // Helper method to get country name from country code
  getCountryName(countryCode: string | undefined): string {
    if (!countryCode) return 'N/A';

    const country = this.countries.find(c => c.code === countryCode);
    return country ? country.name : countryCode;
  }

  private resetData(): void {
    this.docsReleaseData = null;
  }

  closeModal(): void {
    const modalElement = document.getElementById('kt_modal_view_docs_release_data');
    if (modalElement) {
      const modal = bootstrap.Modal.getInstance(modalElement);
      if (modal) {
        modal.hide();
      }
    }
  }
}
